import enums from "./../enums";
import Service from "./../service/index.jsx";
import { showResponseErrorMessage } from "./base.js";

export function getActiveDepositMethods(cb) {
	return (dispatch) => {
		dispatch({ type: enums.DEPOSIT_LOADING, payload: true });
		Service.get("payment-api", "methods/active/Deposit")
			.then((response) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				dispatch({
					type: enums.DEPOSIT_PAYMENT_METHODS,
					payload: response.data.paymentMethods,
				});
				cb?.(response.data);
			})
			.catch((e) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				console.log(e);
			});
	};
}

export function getDepositBonuses() {
	return (dispatch) => {
		Service.get("bonus-api", "bonus", { params: { size: 50, trigger: "Deposit" } })
			.then((response) => {
				dispatch({ type: enums.APP_BONUS_LIST, payload: response.data });
			})
			.catch((e) => {
				console.error(e);
			});
	};
}

export function getFilteredDepositBonuses(data, cb, errCb) {
	return (dispatch) => {
		dispatch({ type: enums.DEPOSIT_LOADING, payload: true });
		Service.post("bonus-api", "bonus/paymentmethod", data)
			.then((response) => {
				dispatch({ type: enums.APP_FILTERED_BONUS_LIST, payload: response.data });
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				console.error(e);
				if (errCb) {
					errCb();
				}
				//dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
			});
	};
}

//
// ────────────────────────────────────────────────────── I ──────────
//   :::::: T H O R P A Y : :  :   :    :     :        :          :
// ────────────────────────────────────────────────────────────────
//
export function newCustomer(cb) {
	return (dispatch) => {
		dispatch({ type: enums.DEPOSIT_LOADING, payload: true });
		Service.post("payment-api", "thorpay/newCustomer")
			.then((response) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				cb(response.data);
			})
			.catch((e) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				console.log(e);
			});
	};
}

function depositGeneric(provider) {
	return (data, cb, errCb) => (dispatch) => {
		dispatch({ type: enums.DEPOSIT_LOADING, payload: true });
		Service.post("payment-api", "deposit", { ...data, provider })
			.then((response) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				cb?.(response.data);
			})
			.catch((e) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg: showResponseErrorMessage(e),
						title: "ERROR",
					},
				});
				if (errCb) errCb(e);
				else cb?.(e);
			});
	};
}

export const depositThorpay = depositGeneric("thorpay");
export const depositSapphirePapara = depositGeneric("sapphirepapara");
export const depositFXcuzdan = depositGeneric("fxcuzdan");
export const depositMonetix = depositGeneric("monetix");
export const depositCrypto = depositGeneric("cryptopay");
export const depositCryptoPayment = depositGeneric("cryptopayment");
export const depositPenapay = depositGeneric("penapay");
export const depositDeltapay = depositGeneric("deltapay");
export const depositFixturka = depositGeneric("fixturka");
export const depositPayco = depositGeneric("payco");
export const depositMFT = depositGeneric("mft");
export const depositBetterBro = depositGeneric("betterbro");
export const depositSkrill = depositGeneric("skrill");
export const depositPayturka = depositGeneric("payturka");
export const depositIxirpay = depositGeneric("ixir");
export const depositMiniHavale = depositGeneric("minihavale");
export const depositPaparazzi = depositGeneric("paparazzi");
export const depositMovenPay = depositGeneric("movenpay_creditcard");
export const depositMovenPayPapara = depositGeneric("movenpay_papara");
export const depositBankTransfer = depositGeneric("bankTransfer");
export const depositBankTransferCepbank = depositGeneric("bankTransfer_cepbank");
export const depositPaparaFast = depositGeneric("hizlipapara");
export const depositOdendibilCepbankQR = depositGeneric("odendibil_cepbank");
export const depositVevopay = depositGeneric("vevopay");
export const depositTurboHavale = depositGeneric("turbohavale");
export const depositTurboYatirim = depositGeneric("turboyatirim");
export const depositGuvenilirQR = depositGeneric("guvenilirqr");
export const depositPiastrix = depositGeneric("piastrix");
export const depositOdendibilPep = depositGeneric("odendibil_pep");
export const depositCoinsPaid = depositGeneric("coinspaid");
export const depositOdebitir = depositGeneric("odebitir");
export const depositUnlimit = depositGeneric("unlimit");
export const depositVpag = depositGeneric("vpag");
export const depositVcreditos = depositGeneric("vcreditos");
export const depositApay = depositGeneric("apay");
export const depositAnindaMFT = depositGeneric("anindamft");
export const depositAnindaCreditCard = depositGeneric("anindaIntegration");
export const depositNuvei = depositGeneric("nuvei");
export const depositTrend = depositGeneric("trendhavale");
export const depositSTP = depositGeneric("stp");

export function getFXBankList() {
	return Service.get("payment-api", "fxcuzdan/getBankList");
}
export function getTrendBankList() {
	return Service.get("payment-api", "trendhavale/banklist");
}

export function getGuvenilirQRBankList() {
	return Service.get("payment-api", "guvenilirqr/banklist");
}

export function getOdebitirBankList() {
	return Service.get("payment-api", "odebitir/banklist");
}

export function getOdendibilBankList(data, cb) {
	return (dispatch) => {
		dispatch({ type: enums.DEPOSIT_LOADING, payload: true });
		Service.post("payment-api", "odendibil/getbanklist", data)
			.then((response) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				dispatch({ type: enums.ODENDIBIL_BANKS, payload: response.data.result });
			})
			.catch((e) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg: "GENERIC_ERROR",
						title: "ERROR",
					},
				});
				cb(e);
			});
	};
}

export function getSms(data, cb) {
	return (dispatch) => {
		dispatch({ type: enums.DEPOSIT_LOADING, payload: true });
		Service.post("payment-api", "thorpay/getSms", data)
			.then((response) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				cb(response.data);
			})
			.catch((e) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				console.log(e);
			});
	};
}
export function smsStatus(data, cb) {
	return (dispatch) => {
		dispatch({ type: enums.DEPOSIT_LOADING, payload: true });
		Service.post("payment-api", "thorpay/smsStatus", data)
			.then((response) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				cb(response.data);
			})
			.catch((e) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				console.log(e);
			});
	};
}
export function paymentStatus(data, cb) {
	return (dispatch) => {
		dispatch({ type: enums.DEPOSIT_LOADING, payload: true });
		Service.post("payment-api", "thorpay/paymentStatus", data)
			.then((response) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				cb(response.data);
			})
			.catch((e) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				console.log(e);
			});
	};
}

export function getBankList(data, cb) {
	return (dispatch) => {
		dispatch({ type: enums.DEPOSIT_LOADING, payload: true });
		Service.get("payment-api", `ixir/bankList/${data}`)
			.then((response) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				dispatch({ type: enums.BANK_LIST, payload: response.data.message.banks });
				cb(response.data);
			})
			.catch((e) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg: "GENERIC_ERROR",
						title: "ERROR",
					},
				});
				cb(e);
			});
	};
}

// ────────────────────────────────────────────────────────────────────────────────

//type card or havale :D, kimlik karmasasi yasamis backendci
// export function depositTrend(data, cb) {
// 	return (dispatch) => {
// 		const { type, ...rest } = data;
// 		dispatch({ type: enums.DEPOSIT_LOADING, payload: true });
// 		Service.post("payment-api", `trendhavale/deposit/${type}`, rest)
// 			.then((response) => {
// 				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
// 				cb(response.data);
// 			})
// 			.catch((e) => {
// 				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
// 				dispatch({
// 					type: enums.ALERT_IN,
// 					payload: {
// 						type: "error",
// 						msg: showResponseErrorMessage(e),
// 						title: "ERROR",
// 					},
// 				});
// 				cb(e);
// 			});
// 	};
// }

export function depositPromotional(code, cb) {
	return (dispatch) => {
		dispatch({ type: enums.DEPOSIT_LOADING, payload: true });
		Service.post("bonus-api", `bonuscode/${code}/activate`)
			.then((response) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				cb(response.data);
			})
			.catch((e) => {
				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
				/* dispatch({
                    type: enums.ALERT_IN, payload: {
                        type: "error",
                        msg: showResponseErrorMessage(e),
                        title: "ERROR"
                    }
                }); */
				cb(e);
			});
	};
}

// export function depositAnindaMFT(data, cb, errCb) {
// 	return (dispatch) => {
// 		dispatch({ type: enums.DEPOSIT_LOADING, payload: true });
// 		Service.post("payment-api", "anindamft/deposit", data)
// 			.then((response) => {
// 				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
// 				cb(response.data);
// 			})
// 			.catch((e) => {
// 				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
// 				dispatch({
// 					type: enums.ALERT_IN,
// 					payload: {
// 						type: "error",
// 						msg: showResponseErrorMessage(e),
// 						title: "ERROR",
// 					},
// 				});
// 				errCb(e);
// 			});
// 	};
// }

// export function depositNuvei(data, cb) {
// 	return (dispatch) => {
// 		dispatch({ type: enums.DEPOSIT_LOADING, payload: true });
// 		Service.post("payment-api", "nuvei/deposit", data)
// 			.then((response) => {
// 				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
// 				cb(response.data);
// 			})
// 			.catch((e) => {
// 				dispatch({ type: enums.DEPOSIT_LOADING, payload: false });
// 				dispatch({
// 					type: enums.ALERT_IN,
// 					payload: {
// 						type: "error",
// 						msg: showResponseErrorMessage(e),
// 						title: "ERROR",
// 					},
// 				});
// 				cb(e);
// 			});
// 	};
// }
